import { render, staticRenderFns } from "./DefaultComponent.vue?vue&type=template&id=12141439&"
import script from "./DefaultComponent.vue?vue&type=script&lang=js&"
export * from "./DefaultComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports